import { render, staticRenderFns } from "./TicketsInfoResort.vue?vue&type=template&id=4e2d8442&scoped=true&lang=pug&"
import script from "./TicketsInfoResort.vue?vue&type=script&lang=js&"
export * from "./TicketsInfoResort.vue?vue&type=script&lang=js&"
import style0 from "./TicketsInfoResort.vue?vue&type=style&index=0&id=4e2d8442&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2d8442",
  null
  
)

export default component.exports